<template>
  <select style="width: 80%;" v-model="model" :disabled="disabled">
    <option :value="''">Choose Company</option>
    <option v-for="(list, index) in options" :value="list.kode" :key="index">
      {{ list.nama_perusahaan }}
    </option>
  </select>
</template>
<script>
export default {
  props: ['options', 'storeName', 'modelName', 'mutationName', 'disabled'],
  created() {
  },
  computed: {
    model: {
      get() {
        return this.$store.state[this.storeName][this.modelName]
      },
      set(newValue) {
        this.$store.commit(this.mutationName, {
          name: this.modelName,
          value: newValue,
        })
      },
    },
  },
}
</script>
